import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsAccordionModule,
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsDateTimePickerModule } from '../../common/component/datetime-picker';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsCardModule } from '../card';
import { CmpsCommentModule } from '../comment';
import { CmpsProgressBarModule } from '../progress-bar';
import { BreakpointDirective } from '../scss/breakpoint.directive';

import { FormComponent } from './form.component';
import { TranslationIdMap } from './form.i18n';
import { ReasonComponent } from './reason/reason.component';
import { ScoreAlertComponent } from './score-alert/score-alert.component';
import { ScoreLabelComponent } from './score-label/score-label.component';

@NgModule({
    declarations: [
        BreakpointDirective,
        FormComponent,
        ReasonComponent,
        ScoreAlertComponent,
        ScoreLabelComponent,
    ],
    exports: [FormComponent],
    imports: [
        CmpsAccordionModule,
        CmpsButtonModule,
        CmpsCardModule,
        CmpsCommentModule,
        CmpsCommonModule,
        CmpsCheckboxModule,
        CmpsDateTimePickerModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsProgressBarModule,
        CmpsRadioModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
    ],
})
export class CmpsEvalFormModule {}
